/**
 * Created by jinbian on 20/09/2017.
 */
import apisauce from "apisauce";

// constructor
const create = (baseURL = window.newsletterURL) => {
    const api = apisauce.create({
        baseURL,
        headers: {
            "Content-Type": "application/json",
        },
        timeout: 10000,
    });

    const subscribeEmail = email =>
        api.post("/", {
            email,
        });


    return {
        subscribeEmail,
    };
};


export default {
    create,
};
